export default __webpack_public_path__ + "static/silkserif-light-italic-47512066f70c39a627a1a709cfe7e8cd.woff2";